import React from 'react'

export class Indicadores extends React.Component {
    render() {
        return (
            <div className={'panel panel-primary'}>
                <div className={'panel-heading'}>Resumen mensual auditorias</div>
                <ul className={'list-group'}>
                    <li className={'list-group-item'}>
                        <span className={'badge'}>${this.props.totalFacturaAnterior}</span>
                        Valor factura anterior
                    </li>
                    <li className={'list-group-item'}>
                        <span className={'badge'}>${this.props.valorActual}</span>
                        Valor real
                    </li>
                    <li className={'list-group-item'}>
                        <span className={'badge'}>${this.props.diferencia}</span>
                        Valor a facturar
                    </li>
                </ul>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/auditorias/resumen-mensual/Indicadores.jsx